import React, { useState } from 'react';
import useGoogleCalendar from '../../../api/useGoogleCalendar';

const GoogleCalendarExample = () => {
  const [dateRange, setDateRange] = useState({
    start: new Date(),
    end: new Date(new Date().setMonth(new Date().getMonth() + 1)) // One month from now
  });
  
  const {
    isInitialized,
    isLoading,
    isSignedIn,
    error,
    events,
    calendars,
    signIn,
    signOut,
    fetchCalendars,
    fetchEvents,
    createEvent
  } = useGoogleCalendar({
    autoSignIn: false
  });

  const handleSignIn = () => {
    signIn();
  };

  const handleSignOut = () => {
    signOut();
  };

  const handleFetchCalendars = async () => {
    const calendarList = await fetchCalendars();
    console.log('Calendars:', calendarList);
  };

  const handleFetchEvents = async () => {
    const params = {
      timeMin: dateRange.start.toISOString(),
      timeMax: dateRange.end.toISOString(),
      maxResults: 20,
      singleEvents: true,
      orderBy: 'startTime'
    };
    
    const eventsList = await fetchEvents('primary', params);
    console.log('Events:', eventsList);
  };

  const handleCreateEvent = async () => {
    const newEvent = {
      summary: 'Hotel La Finca Reservation',
      location: 'Hotel La Finca',
      description: 'New reservation at Hotel La Finca',
      start: {
        dateTime: new Date(new Date().setDate(new Date().getDate() + 7)).toISOString(), // One week from now
        timeZone: 'America/Los_Angeles'
      },
      end: {
        dateTime: new Date(new Date().setDate(new Date().getDate() + 8)).toISOString(), // One week + 1 day
        timeZone: 'America/Los_Angeles'
      },
      attendees: [
        { email: 'guest@example.com' }
      ],
      reminders: {
        useDefault: false,
        overrides: [
          { method: 'email', minutes: 24 * 60 }, // 1 day before
          { method: 'popup', minutes: 30 } // 30 minutes before
        ]
      }
    };
    
    const createdEvent = await createEvent('primary', newEvent);
    console.log('Created event:', createdEvent);
  };

  return (
    <div className="google-calendar-container p-4">
      <h2 className="mb-4">Google Calendar Integration</h2>
      
      {error && (
        <div className="alert alert-danger" role="alert">
          Error: {error.message}
        </div>
      )}
      
      <div className="mb-4">
        <h4>Authentication Status</h4>
        <p>
          <strong>Initialized:</strong> {isInitialized ? 'Yes' : 'No'}<br />
          <strong>Signed In:</strong> {isSignedIn ? 'Yes' : 'No'}<br />
          <strong>Loading:</strong> {isLoading ? 'Yes' : 'No'}
        </p>
        
        <div className="btn-group">
          {!isSignedIn ? (
            <button 
              className="btn btn-primary" 
              onClick={handleSignIn} 
              disabled={!isInitialized || isLoading}
            >
              Sign In with Google
            </button>
          ) : (
            <button 
              className="btn btn-secondary" 
              onClick={handleSignOut} 
              disabled={!isInitialized || isLoading}
            >
              Sign Out
            </button>
          )}
        </div>
      </div>
      
      {isSignedIn && (
        <>
          <div className="mb-4">
            <h4>Calendars</h4>
            <button 
              className="btn btn-info" 
              onClick={handleFetchCalendars} 
              disabled={isLoading}
            >
              Fetch Calendars
            </button>
            
            {calendars.length > 0 && (
              <div className="mt-3">
                <ul className="list-group">
                  {calendars.map(calendar => (
                    <li key={calendar.id} className="list-group-item">
                      <div style={{ backgroundColor: calendar.backgroundColor, width: '10px', height: '10px', display: 'inline-block', marginRight: '10px' }}></div>
                      {calendar.summary} ({calendar.id})
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          
          <div className="mb-4">
            <h4>Events</h4>
            <div className="row mb-3">
              <div className="col">
                <label>Start Date</label>
                <input 
                  type="date" 
                  className="form-control"
                  value={dateRange.start.toISOString().split('T')[0]}
                  onChange={(e) => setDateRange({...dateRange, start: new Date(e.target.value)})}
                />
              </div>
              <div className="col">
                <label>End Date</label>
                <input 
                  type="date" 
                  className="form-control"
                  value={dateRange.end.toISOString().split('T')[0]}
                  onChange={(e) => setDateRange({...dateRange, end: new Date(e.target.value)})}
                />
              </div>
            </div>
            
            <div className="btn-group">
              <button 
                className="btn btn-info" 
                onClick={handleFetchEvents} 
                disabled={isLoading}
              >
                Fetch Events
              </button>
              <button 
                className="btn btn-success" 
                onClick={handleCreateEvent} 
                disabled={isLoading}
              >
                Create Test Event
              </button>
            </div>
            
            {events.length > 0 && (
              <div className="mt-3">
                <ul className="list-group">
                  {events.map(event => (
                    <li key={event.id} className="list-group-item">
                      <h5>{event.summary}</h5>
                      <p>
                        <strong>When:</strong> {new Date(event.start.dateTime || event.start.date).toLocaleString()} - 
                        {new Date(event.end.dateTime || event.end.date).toLocaleString()}
                      </p>
                      {event.description && <p><strong>Description:</strong> {event.description}</p>}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default GoogleCalendarExample;
